class AnimationHomePage {
  elements;

  constructor() {
    this.elements = document.querySelectorAll('[data-trigger="scrollSection"]');
    if (this.elements.length > 0) {
      this._init();
    }
  }

  _init() {
    for (let index = 0; index < this.elements.length; index++) {
      const element = this.elements[index];
      element.addEventListener("click", (event) => {
        this._goto(event);
      });
    }
  }

  _goto(event) {
    event.preventDefault(); // Empêche le comportement par défaut du lien
    const target = event.target.parentNode.nextElementSibling; // Récupère la cible du lien
    if (target) {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  }
}

export const animationHomePage = new AnimationHomePage();
